<template>
  <div class="all-campaigns">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-CC" fill="#fff"></use>
      </svg>
    </breadcrumbs>
    <div class="content-wrapper">
      <div class="table-head">
        <a-space>
          <ButtonGroups
            :pagination="{
              total: params.total,
              page: params.page,
              size: params.size,
            }"
            :tableData="dataSource"
            @pageChange="onPageChange"
          />
        </a-space>
        <a-space>
          <a-input-search
            v-model:value="filter.keyword"
            placeholder="Search..."
            allow-clear
            @search="handleSearch"
          />
          <div ref="sortRef" style="position: relative">
            <artmisads-select
              v-model:value="sortValue"
              :getPopupContainer="() => $refs.sortRef"
              @change="(option) => setFilter('sort', option)"
            >
            <a-select-option value="campaignStatusAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Campaign Status</span>
              </a-select-option>
              <a-select-option value="campaignStatusDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Campaign Status</span>
              </a-select-option>
              <a-select-option value="campaignNameAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Campaign Name</span>
              </a-select-option>
              <a-select-option value="campaignNameDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Campaign Name</span>
              </a-select-option>
              <a-select-option value="startDateAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Start Date</span>
              </a-select-option>
              <a-select-option value="startDateDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Start Date</span>
              </a-select-option>
              <a-select-option value="endDateAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">End Date</span>
              </a-select-option>
              <a-select-option value="endDateDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">End Date</span>
              </a-select-option>
              <a-select-option value="budgetAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Budget</span>
              </a-select-option>
              <a-select-option value="budgetDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Budget</span>
              </a-select-option>
              <a-select-option value="remainingBudgetAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Budget Remaining</span>
              </a-select-option>
              <a-select-option value="remainingBudgetDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">Budget Remaining</span>
              </a-select-option>
            </artmisads-select>
          </div>
        </a-space>
      </div>

      <div class="filters">
        <!-- <div class="filter-item" ref="marketplaceRef">
          <div class="label">Marketplace:</div>
          <CountryHostSelect
            v-model="filter.marketplace"
            :get-popup-container="() => $refs.marketplaceRef"
            @change="(option) => setFilter('marketplace', option)"
          />
        </div> -->
        <div class="filter-item">
          <div class="label">Status:</div>
          <div class="brandBox" ref="statusRef" style="position: relative">
            <artmisads-select
              class="width100"
              :options="statusOptions"
              v-model:value="filter.campaignStatus"
              @select="(id, option) => setFilter('campaignStatus', option)"
              @clear="
                () => {
                  filter.campaignStatus = '';
                  params.page = 1;
                  getList();
                }
              "
              :getPopupContainer="() => $refs.statusRef"
            />
          </div>
        </div>
        <div class="filter-item">
          <div class="label">AcceptStatus:</div>
          <div class="brandBox" ref="acceptRef" style="position: relative">
            <artmisads-select
              class="width100"
              :options="acceptStatusOptions"
              v-model:value="filter.acceptStatus"
              @select="(id, option) => setFilter('acceptStatus', option)"
              @clear="
                () => {
                  filter.acceptStatus = '';
                  params.page = 1;
                  getList();
                }
              "
              :getPopupContainer="() => $refs.acceptRef"
            />
          </div>
        </div>
        <div class="filter-item filter-item-bonus">
          <div class="label">BonusProgram</div>
          <div class="bonus-options">
            <a-checkbox
              :checked="filter.hasActiveBonusProgram === ''"
              @change="() => setBonusProgramFilter('')"
            >
              ALL
            </a-checkbox>
            <a-checkbox
              :checked="filter.hasActiveBonusProgram === 'true'"
              @change="() => setBonusProgramFilter('true')"
            >
              With Bonus
            </a-checkbox>
            <a-checkbox
              :checked="filter.hasActiveBonusProgram === 'false'"
              @change="() => setBonusProgramFilter('false')"
            >
              No Bonus
            </a-checkbox>
          </div>
        </div>
      </div>

      <div class="table-content">
        <artmisads-table
          :loading="loading"
          :columns="columns"
          :data-source="dataSource"
          row-key="id"
          :pagination="{
            total: params.total,
            current: params.page,
            pageSize: params.size,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '50', '100', '200'],
          }"
          :change="onChangePage"
          :scroll="{ x: 1400 }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'dates'">
              <div class="dates">
                <span class="date-label">Start:</span>
                <span class="date-item">{{
                  moment(record.startDateTimeInEpochMills).tz(timezone).format('YYYY-MM-DD')
                }}</span>
              </div>
              <div class="dates">
                <span class="date-label">End:</span>
                <span class="date-item">{{
                  moment(record.endDateTimeInEpochMills).tz(timezone).format('YYYY-MM-DD')
                }}</span>
              </div>
            </template>
            <template v-else-if="column.dataIndex === 'budget'">
              {{ CURRENCY_DATA_MAPPER[record.currencyCode] }} {{ formatMoney(record.totalBudget) }}
            </template>
            <template v-else-if="column.dataIndex === 'budgetRemaining'">
              {{ CURRENCY_DATA_MAPPER[record.currencyCode] }}
              {{ formatMoney(record.budgetRemaining ?? record.remainingBudget) }}
            </template>
            <template v-else-if="column.dataIndex === 'bonusProgram'">
              <template v-if="record.bonusProgramId || record.bonusProgramTitle">
                <a-popover
                  trigger="click"
                  placement="rightTop"
                  :overlayStyle="{ maxWidth: '480px' }"
                  @openChange="(visible) => onBonusPopoverOpen(visible, record)"
                >
                  <template #title>
                    <div class="popover-title">BonusProgramInfo</div>
                  </template>
                  <template #content>
                    <bonusProgramInfoPopover
                      v-if="activeBonusProgramId === getBonusProgramId(record)"
                      :program-id="getBonusProgramId(record)"
                    />
                  </template>
                  <span class="program-link">{{ record.bonusProgramTitle || 'ProgramTitle' }}</span>
                </a-popover>
              </template>
              <span v-else class="na-text">N/A</span>
            </template>
            <template v-else-if="column.dataIndex === 'status'">
              <Status :type="returnStatusType(record.campaignStatus)" :text="record.campaignStatus" />
            </template>
            <template v-else-if="column.dataIndex === 'acceptStatus'">
              <div class="accept-cell">
                <Status
                  :type="returnStatusType(record.acceptStatus)"
                  :text="formatAcceptStatus(record.acceptStatus)"
                  :noBorder="true"
                />
                <!-- v-if="isNotAccepted(record.acceptStatus)&&record.jumpUrl" -->
                  
                <!-- <a
                  target="_blank"
                  rel="noopener noreferrer"
                  class="external-link"
                  @click="openCampaignUrl(record)"
                >
                  <Icon name="lianjie" class="link-icon" />
                </a> -->
              </div>
            </template>
            <template v-else-if="column.dataIndex === 'bonusProgramTitle'">
              <a
              v-if="record.bonusProgramTitle"
              class="linkStyle"
              href="#"
              @click.prevent="openBonusRule(record)"
            >
              {{ record.bonusProgramTitle }}
            </a>
            <span v-else>
              No Bonus
            </span>
            </template>
            <template v-else-if="column.dataIndex === 'action'">
              <div class="button-box">
                <artmisads-select-button  v-if="record.bonusProgramTitle" type="primary" size="small"  @click.prevent="openBonusRule(record)">
                View Bonus Program
              </artmisads-select-button>
              <artmisads-select-button v-if="isNotAccepted(record.acceptStatus)&&record.jumpUrl" size="small" @click="openCampaignUrl(record)">
                  Accept in Amazon
              </artmisads-select-button>
              </div>
              
            </template>
          </template>
        </artmisads-table>
      </div>
    </div>
    <storeIdNoticeModal ref="storeIdNoticeModalRef" />
    <BonusRuleModal ref="bonusRuleModalRef" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import breadcrumbs from '~/components/breadcrumbs.vue';
import ButtonGroups from '~/components/buttonGroups.vue';
import Icon from '@/components/Icon.vue';
import bonusProgramInfoPopover from './components/bonusProgramInfoPopover.vue';
import { creatorConnectionsApi } from '@/server/index';
import moment from 'moment';
import { BILLING_TIME_TZ, CURRENCY_DATA_MAPPER } from '~/contants/common.js';
import Status from '@/components/Status.vue';
import CountryHostSelect from '@/components/CountryHostSelect.vue'
import storeIdNoticeModal from './components/storeIdNoticeModal.vue'
import BonusRuleModal from './components/bonusRuleModal.vue'
const statusOptions = ref([
  { label: 'All', value: '' },
  { label: 'DELIVERING', value: 'delivering' },
  { label: 'ENDED', value: 'ended' },
  { label: 'EXPIRED', value: 'expired' },
  { label: 'OUT OF BUDGET', value: 'out_of_budget' },
  { label: 'CREATED', value: 'created' },
  { label: 'DELETED', value: 'deleted' },
  { label: 'SCHEDULED', value: 'scheduled' },
  { label: 'ENDED_GRACE_PERIOD', value: 'ended_grace_period' },
]);
const storeIdNoticeModalRef = ref(null);
const bonusRuleModalRef = ref(null);
const acceptStatusOptions = ref([
  { label: 'All', value: '' },
  { label: 'ACCEPTED', value: 'accepted' },
  { label: 'NOT ACCEPTED', value: 'not_accepted' },
]);

const filter = ref({
  campaignStatus: '',
  acceptStatus: '',
  keyword: '',
  sortField: 'campaignStatus',
  sortDirection: 'desc',
  marketplace: 'amazon.com',
  hasActiveBonusProgram: 'true',
});

const timezone = BILLING_TIME_TZ[filter.value.marketplace];
const sortValue = ref('campaignStatusDesc');
const params = ref({ page: 1, size: 10, total: 0 });
const activeBonusProgramId = ref(null);

const breadcrumbsData = ref({
  title: 'All Campaigns',
  hasTitleIcon: true,
  color: '#9C7AFB',
  links: [
    { name: 'Home', path: '/publisher/dashboard' },
    { name: 'Creator Connections', path: '/publisher/creatorConnections/allCampaigns' },
    { name: 'All Campaigns', path: '/publisher/creatorConnections/allCampaigns' },
  ],
});

const dataSource = ref([]);
const loading = ref(false);

const columns = ref([
  { title: 'Campaign Name', dataIndex: 'campaignName', key: 'campaignName', width: 360 },
  { title: 'Brand', dataIndex: 'brandName', key: 'brandName', width: 120 },
  { title: 'Campaign Status', dataIndex: 'status', key: 'status', width: 230 },
  { title: 'Dates', dataIndex: 'dates', key: 'dates', width: 180 },
  { title: 'Budget', dataIndex: 'budget', key: 'budget', width: 120 },
  { title: 'BudgetRemaining', dataIndex: 'budgetRemaining', key: 'budgetRemaining', width: 140 },
  { title: 'BonusProgram', dataIndex: 'bonusProgramTitle', key: 'bonusProgramTitle', width: 140 },
  { title: 'AcceptStatus', dataIndex: 'acceptStatus', key: 'acceptStatus', width: 160 },
  { title: 'Action', dataIndex: 'action', key: 'action', width: 180,fixed: 'right' },
]);
const openBonusRule = (record) => {
  // /publisher/creatorConnections/programdetails/15
  window.open(`/publisher/creatorConnections/programdetails/${record.bonusProgramId}`, '_blank');
};

const formatMoney = (val) => Number(val ?? 0).toFixed(2);

const getBonusProgramId = (record) => record.bonusProgramId || record.programId;

const formatAcceptStatus = (status) => {
  if (!status) return '';
  if (status === 'ACCEPTED' || status === 'accepted') return 'Accepted';
  if (status === 'NOT_ACCEPTED' || status === 'not_accepted') return 'Not Accepted';
  return status;
};

const isNotAccepted = (status) =>
  status === 'NOT_ACCEPTED' || status === 'not_accepted' || status === 'NOT ACCEPTED';

const returnStatusType = (type) => {
  if (type === "ACTIVE" || type === "SCHEDULED" || type === "accepted") return "active"
  if (type === "EXPIRED") return "finished"
  if (type === "OUT_OF_BUDGET") return "pending"
  if (type === "ENDED_GRACE_PERIOD"||type === "NOT_ACCEPTED" || type === "ENDED" ) return "inactive"
  if (type === "DELETED") return "not_authorized"
  if (type === "DELIVERING" || type === "CREATED") return "delivering"
  return "inactive"
};
const openCampaignUrl = (record) => {
  // window.open(record.campaignUrl, '_blank');

  if(record.hasAssociateStoreId){
    if(record.jumpUrl){
      window.open(record.jumpUrl, '_blank');
    }else{
      storeIdNoticeModalRef.value?.show()
    }
  }else{
    storeIdNoticeModalRef.value?.show();
  }
};

const onBonusPopoverOpen = (visible, record) => {
  activeBonusProgramId.value = visible ? getBonusProgramId(record) : null;
};

const onPageChange = (page) => {
  params.value.page = page;
  getList();
};

const handleSearch = () => {
  params.value.page = 1;
  getList();
};

const onBonusProgramFilterChange = () => {
  params.value.page = 1;
  getList();
};

const setBonusProgramFilter = (value) => {
  filter.value.hasActiveBonusProgram = value;
  onBonusProgramFilterChange();
};

const setFilter = (key, value) => {
  if (key !== 'sort') {
    filter.value[key] = value.value;
  } 
  else if (key === 'marketplace') {
    filter.value.marketplace = value.value;
    params.value.page = 1;
    getList();
  }
  else {
    const sortMap = {
      campaignStatusAsc: ['campaignStatus', 'asc'],
      campaignStatusDesc: ['campaignStatus', 'desc'],
      campaignNameAsc: ['campaignName', 'asc'],
      campaignNameDesc: ['campaignName', 'desc'],
      startDateAsc: ['startDate', 'asc'],
      startDateDesc: ['startDate', 'desc'],
      endDateAsc: ['endDate', 'asc'],
      endDateDesc: ['endDate', 'desc'],
      budgetAsc: ['budget', 'asc'],
      budgetDesc: ['budget', 'desc'],
      remainingBudgetAsc: ['remainingBudget', 'asc'],
      remainingBudgetDesc: ['remainingBudget', 'desc'],
    };
    const [field, direction] = sortMap[value] || ['campaignName', 'asc'];
    filter.value.sortField = field;
    filter.value.sortDirection = direction;
  }
  params.value.page = 1;
  getList();
};

const onChangePage = (data) => {
  params.value.page = data.current;
  params.value.size = data.pageSize;
  getList();
};

const getList = () => {
  loading.value = true;
  const param = {
    ...params.value,
    ...filter.value,
    hasActiveBonusProgram: filter.value.hasActiveBonusProgram || undefined,
  };

  creatorConnectionsApi
    .getCampaignList(param)
    .then((res) => {
      dataSource.value = res.data?.data || res.data || [];
      params.value.total = res.data?.total ?? res.total ?? 0;
    })
    .finally(() => {
      loading.value = false;
    });
};

onMounted(() => {
  getList();
});
</script>

<style scoped lang="less">
.button-box{
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.linkStyle {
  color: #7653da;
  text-decoration: underline;
}
.all-campaigns {
  .content-wrapper {
    display: block !important;
  }
}

.table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
}

.filters {
  display: flex;
  gap: 22px;
  padding: 15px 16px;
  margin: 16px 0;
  border-radius: 8px;
  background: #f8f7fc;

  .filter-item {
    .label {
      color: #0f0629;
      font-family: 'Sora';
      font-size: 14px;
      font-weight: 500;
      opacity: 0.9;
      margin-bottom: 8px;
    }
  }

  .filter-item-bonus {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .bonus-options {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;
      background-color: var(--bg-gray-6);
    border-radius: 8px;
    height: 32px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    }

    // :deep(.ant-checkbox-wrapper) {
    //   font-size: 13px;
    //   color: rgba(15, 6, 41, 0.7);
    // }
  }
}

.width100 {
  width: 220px;
}

.date-label {
  display: inline-block;
  width: 40px !important;
  font-size: 13px;
  line-height: 15px;
  color: rgba(15, 6, 41, 0.5);
}

.date-item {
  font-size: 13px;
  font-weight: 500;
  line-height: 15px;
  color: rgba(15, 6, 41, 0.9);
  margin-left: 10px;
}

.program-link {
  color: #26aadc;
  cursor: pointer;
  text-decoration: underline;
}

.na-text {
  color: rgba(15, 6, 41, 0.4);
}

.accept-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.external-link {
  display: inline-flex;
  color: rgba(15, 6, 41, 0.45);

  .link-icon {
    font-size: 14px;
  }

  &:hover {
    color: #26aadc;
  }
}

.popover-title {
  font-weight: 600;
  font-size: 14px;
}
</style>
